import { whyChooseUsData } from "../data/mock";
import {
  GraduationCap, Building2, Clock, Banknote, HeadphonesIcon, ShieldCheck
} from "lucide-react";

const icons = [
  GraduationCap, Building2, Clock, Banknote, HeadphonesIcon, ShieldCheck
];

export const WhyChooseUs = () => {
  return (
    <section id="why-us" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-brand-50 rounded-full px-4 py-1.5 mb-5 border border-brand-100">
            <ShieldCheck className="w-4 h-4 text-brand-600" />
            <span className="text-sm font-medium text-brand-700">Why Choose Us</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Built on Trust, Delivered with Excellence
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto text-base">
            What sets Fix My AC apart from the rest — technical expertise backed by real execution capability.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseUsData.map((item, index) => {
            const IconComp = icons[index] || ShieldCheck;
            return (
              <div
                key={index}
                className="group relative bg-white rounded-2xl p-7 border border-slate-100 hover:border-brand-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                {/* Number watermark */}
                <span className="absolute top-4 right-5 text-5xl font-bold text-slate-50 group-hover:text-brand-50 transition-colors duration-300 select-none">
                  0{index + 1}
                </span>

                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-brand-50 group-hover:bg-brand-100 flex items-center justify-center mb-5 transition-colors duration-300">
                    <IconComp className="w-5.5 h-5.5 text-brand-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-2.5 group-hover:text-brand-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
